module.exports = __webpack_public_path__ + "img/Mobility.7dfb3586.jpeg";